export default function BoardViewIcon({ size = 20, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <rect x="3.5" y="4" width="5" height="16" rx="1.5" />
            <rect x="10" y="4" width="5" height="11" rx="1.5" />
            <rect x="16.5" y="4" width="4" height="7" rx="1.5" />
        </svg>
    );
}
